import { Grid, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import clientUtils from '../../../Utils/clientUtils';

const OutputExtractors = () => {
  const {
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext();
  const [outputExtractors, setOutputExtractors] = useState(getValues('aiEngineConfig.inferenceOptions.outputExtractors') ?? {});

  const getList = () => {
    const outputExtractors = getValues('aiEngineConfig.inferenceOptions.outputExtractors');
    setOutputExtractors(outputExtractors);
  };

  const handleChange = (e, key, field) => {
    let outputExtractors = getValues('aiEngineConfig.inferenceOptions.outputExtractors');
    let outputExtractor = outputExtractors[key];
    if (!outputExtractor) {
      return;
    }
    const stringExtractor = outputExtractor.stringExtractor;
    if (outputExtractors && field === 'regEx') {
      outputExtractors[key]['stringExtractor'] = { ...stringExtractor, 'regEx': e.target.value };
    }
    else if (outputExtractors && field === 'groupIndex') {
      outputExtractors[key]['stringExtractor'] = { ...stringExtractor,'groupIndex': Number(e.target.value) };
    }
    else if (outputExtractors && field === 'matchIndex') {
      outputExtractors[key]['stringExtractor'] = { ...stringExtractor,'matchIndex': Number(e.target.value) };
    }
    setValue('aiEngineConfig.inferenceOptions.outputExtractors', outputExtractors);
  }

  useEffect(() => {
    getList();
  }, []);
  // useEffect(() => {
  //   console.log('outputExtractors changed', outputExtractors)
  // }, [outputExtractors]);
  // useEffect(() => {
  //   console.log('outcomes changed', getValues('aiEngineConfig.outcomes'));
  //   getList();
  // }, [getValues('aiEngineConfig.outcomes')]);
  return (
    <>
      <Grid container spacing={1} direction="row" sx={{ pt: 1 }}>
        {Object.keys(outputExtractors).map((key, index) => (
          <React.Fragment key={key}>
            <Grid item xs={3}>
              <TextField
                id="name"
                label="Name"
                variant="outlined"
                placeholder=""
                size="small"
                fullWidth
                defaultValue={key}
                disabled
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                id="regEx"
                label="RegEx"
                variant="outlined"
                placeholder=""
                size="small"
                fullWidth
                name='regEx'
                onChange={(e) => handleChange(e, key, 'regEx')}
                defaultValue={outputExtractors[key] && outputExtractors[key]['stringExtractor'] && outputExtractors[key]['stringExtractor']['regEx'] ? outputExtractors[key]['stringExtractor']['regEx'] : ''}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                id="matchIndex"
                label="Match Index"
                variant="outlined"
                placeholder=""
                size="small"
                fullWidth
                onChange={(e) => handleChange(e, key, 'matchIndex')}
                defaultValue={outputExtractors[key] && outputExtractors[key]['stringExtractor'] && outputExtractors[key]['stringExtractor']['matchIndex'] >=0 ? outputExtractors[key]['stringExtractor']['matchIndex'] : 0}
                onKeyPress={clientUtils.keypress}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                id="groupIndex"
                label="Group Index"
                variant="outlined"
                placeholder=""
                size="small"
                fullWidth
                name='groupIndex'
                onChange={(e) => handleChange(e, key, 'groupIndex')}
                defaultValue={outputExtractors && outputExtractors[key]['stringExtractor'] && outputExtractors[key]['stringExtractor']['groupIndex'] >=0 ? outputExtractors[key]['stringExtractor']['groupIndex'] : -1}
                helperText="Note:(-1 to disable)"
                onKeyPress={clientUtils.keypress}
              />
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </>
  );
};

export default OutputExtractors;
